<template>
  <div class="student-data__component">
    <div class="student-view__panel-content">
      <par-digital-contract-info-modal
        @close="closeParDigitalContractInfoModal"
        v-if="showParDigitalContractInfoModal"
        :payment-plan="paymentPlan"
        :digital-contract-data="digitalContractData"
      />
      <div class="panel__row">
        <div class="panel__col">
          <p class="panel__title">
            Nome
          </p>
          <div> {{ student.name || '-' }} </div>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            CPF
          </p>
          <div> {{ student.cpf || '-' }} </div>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Telefone
          </p>
          <div> {{ maskCellphoneField || '-' }} </div>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Email
          </p>
          <div> {{ student.email || '-' }} </div>
        </div>
      </div>
      <div class="panel__row">
        <br>
      </div>
      <div class="panel__row">
        <div class="panel__col">
          <student-info
            label="Status"
            :value="paymentPlan.status"
            :badge-text="paymentPlan.translatedStatus"
            :badge="true"
          />
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Status do Contrato Digital
          </p>
          <div> {{ documentData ? documentData.status : '-' }} </div>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Observações
          </p>
          <div> {{ paymentPlan.observations || paymentPlan.reprovation_reason || '-' }} </div>
        </div>
        <div class="panel__col">
          <p class="panel__title">
          </p>
        </div>
      </div>
      <div class="panel__row">
        <br>
      </div>
      <div class="panel__row">
        <div v-if="canShowContractSenderButton">
          <button
            type="button"
            class="btn btn-primary"
            @click="openParDigitalContractInfoModal"
          >
            Enviar Contrato Digital
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StudentInfo from 'components/StudentInfo';
import ParcelamentoService from 'services/ParcelamentoService';
import ParDigitalContractInfoModal from './ParDigitalContractInfoModal';

export default {
  data() {
    return {
      showParDigitalContractInfoModal: false,
      digitalContractData: {},
      error: false,
      enableButton: false,
    };
  },
  components: {
    StudentInfo,
    ParDigitalContractInfoModal,
  },
  props: {
    student: {
      type: Object,
      default: () => {},
    },
    paymentPlan: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    maskCellphoneField() {
      if (this.student.cellphone) {
        return `(${this.student.cellphone.slice(0, 2)}) ${this.student.cellphone.slice(2, 6)}-${this.student.cellphone
          .slice(6)}`;
      }
      return '';
    },
    documentData() {
      return this.digitalContractData.documentData;
    },
    canShowContractSenderButton() {
      return !this.error && this.enableButton && this.paymentPlan.planType !== 'digital_enrollment';
    },
  },
  mounted() {
    if (this.paymentPlan.status === 'approved' && !this.paymentPlan.digitalContractSigned) {
      this.loadDigitalContractData();
    }
  },
  methods: {
    openParDigitalContractInfoModal() {
      this.showParDigitalContractInfoModal = true;
    },
    closeParDigitalContractInfoModal() {
      this.showParDigitalContractInfoModal = false;
    },
    loadDigitalContractData() {
      ParcelamentoService.getDigitalContractData(this.paymentPlan)
        .then((response) => {
          this.digitalContractData = response;
          if (!this.documentData || this.documentData.status === 'Cancelado'
              || this.documentData.status === 'Expirado') {
            this.enableButton = true;
          }
        }).catch((error) => {
          this.$alert.notifyAlert(error.response.data.message);
          this.error = true;
        });
    },
  },
};
</script>
